// import React, { useEffect, useState } from 'react'
// import { createOTAttendance } from '../../../services/AttendanceService'
// import LoadingDialog from '../../../helper/LoadingDialog'
// import ResponseDialog from '../../../helper/ResponseDialog'
// import QRScannerModal from '../qr-scanner/QRScannerModal'

// const Transaction = {
//     TIME_IN: 1,
//     TIME_OUT: 2
// }

// const locationWorkingAtMap = {
//     HOME: 1,
//     OFFICE: 2,
//     OFFSITE: 3
// }

// const OTAttendanceActions = () => {
//     const [selectedLocation, setSelectedLocation] = useState('HOME')
//     const [currentTime, setCurrentTime] = useState(new Date())
//     const [loading, setLoading] = useState(false)
//     const [responseMessage, setResponseMessage] = useState('')
//     const [showResponseDialog, setShowResponseDialog] = useState(false)
//     const [currentTransaction, setCurrentTransaction] = useState(null)
//     const [qrCode, setQRCode] = useState(null)
//     const [reason, setReason] = useState('')
//     const [isQrExempted, setIsQrExempted] = useState(false)

//     // Offsite state
//     const [offsiteLocation, setOffsiteLocation] = useState('')
//     const [offsiteTasks, setOffsiteTasks] = useState('')
//     const [startTime, setStartTime] = useState('')
//     const [endTime, setEndTime] = useState('')

//     useEffect(() => {
//         const timer = setInterval(() => setCurrentTime(new Date()), 1000)

//         const checkQRExemption = () => {
//             const qrExempt = localStorage.getItem('isQrExempted')
//             setIsQrExempted(qrExempt === '1')
//         }

//         checkQRExemption()
//         return () => clearInterval(timer)
//     }, [])

//     const formatTime = currentTime.toLocaleTimeString([], {
//         hour: '2-digit',
//         minute: '2-digit',
//         second: '2-digit',
//         hour12: true
//     })

//     const formatDate = currentTime.toLocaleDateString([], {
//         weekday: 'long',
//         year: 'numeric',
//         month: 'long',
//         day: 'numeric'
//     })

//     const handleLocationChange = (event) => {
//         setSelectedLocation(event.target.value)
//     }

//     const handleClockAction = async (transaction) => {
//         if (transaction === Transaction.TIME_IN && selectedLocation !== 'OFFSITE' && !reason.trim()) {
//             setShowResponseDialog(true)
//             setResponseMessage('Please provide a reason to proceed with your overtime request.')
//             return
//         }

//         setCurrentTransaction(transaction)

//         const workingAt = locationWorkingAtMap[selectedLocation]
//         if (workingAt === locationWorkingAtMap.OFFSITE || isQrExempted) {
//             // Direct record without QR
//             recordAttendance(transaction, null, reason)
//         }
//     }

//     const handleAttendanceWithQR = (qrData) => {
//         setQRCode(qrData)
//         const isTimeIn = currentTransaction === Transaction.TIME_IN
//         recordAttendance(currentTransaction, qrData, isTimeIn ? reason : '')
//     }

//     const recordAttendance = async (transaction, qrcode, reason = '') => {
//         const workingAt = locationWorkingAtMap[selectedLocation]

//         if (
//             workingAt === locationWorkingAtMap.OFFSITE &&
//             (!startTime || !endTime || !offsiteLocation.trim() || !offsiteTasks.trim())
//         ) {
//             setResponseMessage(
//                 'Please complete all required offsite details: Start Time, End Time, Location, and Purpose.'
//             )
//             setShowResponseDialog(true)
//             setLoading(false)
//             setCurrentTransaction(null)
//             return
//         }

//         const attendance = {
//             transaction,
//             workingAt,
//             remarks: workingAt === locationWorkingAtMap.OFFSITE ? offsiteTasks : '',
//             qrcode,
//             isQrExempted: isQrExempted || locationWorkingAtMap[selectedLocation] === locationWorkingAtMap.OFFSITE,
//             isOvertime: transaction === Transaction.TIME_OUT && reason !== '',
//             reason,
//             ...(workingAt === locationWorkingAtMap.OFFSITE && {
//                 offsiteDetails: {
//                     timeStart: startTime,
//                     timeEnd: endTime,
//                     location: offsiteLocation,
//                     purpose: offsiteTasks
//                 }
//             })
//         }

//         await submitAttendance(attendance)
//     }

//     const submitAttendance = async (attendance) => {
//         setLoading(true)
//         try {
//             const result = await createOTAttendance(attendance)
//             setResponseMessage(result.error || result.message)
//         } catch {
//             setResponseMessage('An error occurred while recording attendance.')
//         } finally {
//             setLoading(false)
//             setShowResponseDialog(true)
//             setCurrentTransaction(null)
//         }
//     }

//     return (
//         <div className="flex flex-col h-full overflow-auto">
//             <div className="flex-1 min-w-[320px] p-4">
//                 <h3 className="text-2xl font-semibold">OT Clock In / Out</h3>

//                 <div className="p-6 text-center">
//                     <p className="text-md font-semibold text-red-700">{formatDate}</p>
//                     <h3 className="text-6xl font-bold p-4">{formatTime}</h3>
//                 </div>

//                 <div className="p-4 flex space-x-4 items-center justify-center overflow-x-auto">
//                     {['HOME', 'OFFICE', 'OFFSITE'].map((location) => (
//                         <label
//                             key={location}
//                             className={`flex items-center text-xl px-4 py-2 rounded ${
//                                 selectedLocation === location
//                                     ? location === 'HOME'
//                                         ? 'bg-red-300'
//                                         : location === 'OFFICE'
//                                           ? 'bg-green-300'
//                                           : 'bg-blue-300'
//                                     : 'bg-transparent'
//                             }`}
//                         >
//                             <input
//                                 type="radio"
//                                 value={location}
//                                 checked={selectedLocation === location}
//                                 onChange={handleLocationChange}
//                                 className="mr-2"
//                             />
//                             {location}
//                         </label>
//                     ))}
//                 </div>

//                 {selectedLocation === 'OFFSITE' && (
//                     <div className="p-4 space-y-4">
//                         <div>
//                             <label className="block text-lg font-medium mb-2">
//                                 Time Range <span className="text-red-500">*</span>
//                             </label>
//                             <div className="flex gap-2">
//                                 <input
//                                     type="time"
//                                     value={startTime}
//                                     onChange={(e) => setStartTime(e.target.value)}
//                                     className={`w-full p-2 border ${!startTime ? 'border-red-500' : 'border-gray-300'} rounded`}
//                                 />
//                                 <input
//                                     type="time"
//                                     value={endTime}
//                                     onChange={(e) => setEndTime(e.target.value)}
//                                     className={`w-full p-2 border ${!endTime ? 'border-red-500' : 'border-gray-300'} rounded`}
//                                 />
//                             </div>
//                         </div>

//                         <div>
//                             <label className="block text-lg font-medium mb-2">
//                                 Location <span className="text-red-500">*</span>
//                             </label>
//                             <input
//                                 type="text"
//                                 value={offsiteLocation}
//                                 onChange={(e) => setOffsiteLocation(e.target.value)}
//                                 className={`w-full p-2 border ${!offsiteLocation.trim() ? 'border-red-500' : 'border-gray-300'} rounded`}
//                                 placeholder="e.g., Client Office, Makati"
//                             />
//                         </div>

//                         <div>
//                             <label className="block text-lg font-medium mb-2">
//                                 Tasks / Purpose <span className="text-red-500">*</span>
//                             </label>
//                             <textarea
//                                 value={offsiteTasks}
//                                 onChange={(e) => setOffsiteTasks(e.target.value)}
//                                 className={`w-full p-2 border ${!offsiteTasks.trim() ? 'border-red-500' : 'border-gray-300'} rounded`}
//                                 rows={3}
//                                 placeholder="e.g., Project discussion with client"
//                             />
//                         </div>
//                     </div>
//                 )}

//                 {/* <div className="mb-4">
//                     <label htmlFor="reason" className="block text-sm font-medium text-gray-700 mb-1">
//                         REASON
//                     </label>
//                     <textarea
//                         id="reason"
//                         rows="4"
//                         value={reason}
//                         onChange={(e) => setReason(e.target.value)}
//                         className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 p-4"
//                         placeholder="Explain your reason for working overtime."
//                     ></textarea>
//                 </div> */}

//                 {selectedLocation !== 'OFFSITE' && (
//                     <div className="mb-4">
//                         <label htmlFor="reason" className="block text-sm font-medium text-gray-700 mb-1">
//                             REASON
//                         </label>
//                         <textarea
//                             id="reason"
//                             rows="4"
//                             value={reason}
//                             onChange={(e) => setReason(e.target.value)}
//                             className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 p-4"
//                             placeholder="Explain your reason for working overtime."
//                         ></textarea>
//                     </div>
//                 )}

//                 <div className="p-4 flex space-x-4 justify-center">
//                     <button
//                         onClick={() => handleClockAction(Transaction.TIME_IN)}
//                         className="bg-blue-500 text-white px-6 py-2 w-40 rounded shadow hover:bg-blue-600 text-xl"
//                     >
//                         TIME IN
//                     </button>
//                     <button
//                         onClick={() => handleClockAction(Transaction.TIME_OUT)}
//                         className="bg-red-500 text-white px-6 py-2 w-40 rounded shadow hover:bg-red-600 text-xl"
//                     >
//                         TIME OUT
//                     </button>
//                 </div>

//                 <LoadingDialog loading={loading} />
//                 <ResponseDialog
//                     open={showResponseDialog}
//                     onClose={() => setShowResponseDialog(false)}
//                     responseMessage={responseMessage}
//                 />

//                 {locationWorkingAtMap[selectedLocation] !== locationWorkingAtMap.OFFSITE &&
//                     !isQrExempted &&
//                     currentTransaction && (
//                         <QRScannerModal onCancel={() => setCurrentTransaction(null)} onScan={handleAttendanceWithQR} />
//                     )}
//             </div>
//         </div>
//     )
// }

// export default OTAttendanceActions

import React, { useEffect, useState } from 'react'
import { createOTAttendance } from '../../../services/AttendanceService'
import LoadingDialog from '../../../helper/LoadingDialog'
import ResponseDialog from '../../../helper/ResponseDialog'
import QRScannerModal from '../qr-scanner/QRScannerModal'

const Transaction = {
    TIME_IN: 1,
    TIME_OUT: 2
}

const locationWorkingAtMap = {
    HOME: 1,
    OFFICE: 2,
    OFFSITE: 3
}

const OTAttendanceActions = () => {
    const [selectedLocation, setSelectedLocation] = useState('HOME')
    const [currentTime, setCurrentTime] = useState(new Date())
    const [loading, setLoading] = useState(false)
    const [responseMessage, setResponseMessage] = useState('')
    const [responseSeverity, setResponseSeverity] = useState('error')
    const [showResponseDialog, setShowResponseDialog] = useState(false)
    const [currentTransaction, setCurrentTransaction] = useState(null)
    const [qrCode, setQRCode] = useState(null)
    const [reason, setReason] = useState('')
    const [isQrExempted, setIsQrExempted] = useState(false)

    // Offsite state
    const [offsiteLocation, setOffsiteLocation] = useState('')
    const [offsiteTasks, setOffsiteTasks] = useState('')
    const [startTime, setStartTime] = useState('')
    const [endTime, setEndTime] = useState('')

    useEffect(() => {
        const timer = setInterval(() => setCurrentTime(new Date()), 1000)
        setIsQrExempted(localStorage.getItem('isQrExempted') === '1')
        return () => clearInterval(timer)
    }, [])

    const formatTime = currentTime.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
    })

    const formatDate = currentTime.toLocaleDateString([], {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    })

    const handleLocationChange = (e) => setSelectedLocation(e.target.value)

    const handleClockAction = (transaction) => {
        setCurrentTransaction(transaction)

        if (transaction === Transaction.TIME_IN && selectedLocation !== 'OFFSITE' && !reason.trim()) {
            setResponseSeverity('error')
            setResponseMessage('Please provide a reason for your overtime request.')
            setShowResponseDialog(true)
            return
        }

        const workingAt = locationWorkingAtMap[selectedLocation]
        if (workingAt === locationWorkingAtMap.OFFSITE || isQrExempted) {
            recordAttendance(transaction, null, reason)
        }
    }

    const handleAttendanceWithQR = (qrData) => {
        setQRCode(qrData)
        const isTimeIn = currentTransaction === Transaction.TIME_IN
        recordAttendance(currentTransaction, qrData, isTimeIn ? reason : '')
    }

    const recordAttendance = async (transaction, qrcode, reason = '') => {
        const workingAt = locationWorkingAtMap[selectedLocation]

        if (
            workingAt === locationWorkingAtMap.OFFSITE &&
            (!startTime || !endTime || !offsiteLocation.trim() || !offsiteTasks.trim())
        ) {
            setResponseSeverity('error')
            setResponseMessage('Complete all required offsite fields.')
            setShowResponseDialog(true)
            return
        }

        const attendance = {
            transaction,
            workingAt,
            remarks: workingAt === locationWorkingAtMap.OFFSITE ? offsiteTasks : '',
            qrcode,
            isQrExempted: isQrExempted || workingAt === locationWorkingAtMap.OFFSITE,
            isOvertime: transaction === Transaction.TIME_OUT && !!reason.trim(),
            reason,
            ...(workingAt === locationWorkingAtMap.OFFSITE && {
                offsiteDetails: {
                    timeStart: startTime,
                    timeEnd: endTime,
                    location: offsiteLocation,
                    purpose: offsiteTasks
                }
            })
        }

        try {
            setLoading(true)
            const result = await createOTAttendance(attendance)
            setResponseSeverity(result.error ? 'error' : 'success')
            setResponseMessage(result.error || result.message)
        } catch {
            setResponseSeverity('error')
            setResponseMessage('An error occurred while recording attendance.')
        } finally {
            setLoading(false)
            setShowResponseDialog(true)
            setCurrentTransaction(null)
        }
    }

    return (
        <div className="card-surface flex flex-col h-full overflow-auto p-6">
            <div className="flex-1 min-w-0">
                <h2 className="text-3xl font-bold text-gray-800 mb-6">Overtime Clock In / Out</h2>

                <div className="text-center mb-6">
                    <p className="text-xs font-medium text-gray-400 uppercase tracking-widest">{formatDate}</p>
                    <h3 className="text-6xl font-light text-gray-900 tabular-nums mt-2">{formatTime}</h3>
                </div>

                <div className="flex flex-wrap justify-center gap-3 mb-6">
                    {['HOME', 'OFFICE', 'OFFSITE'].map((location) => (
                        <label
                            key={location}
                            className={`cursor-pointer transition-colors duration-150 ${
                                selectedLocation === location
                                    ? location === 'HOME'
                                        ? 'badge-danger'
                                        : location === 'OFFICE'
                                          ? 'badge-success'
                                          : 'badge-info'
                                    : 'badge-neutral hover:bg-gray-200'
                            }`}
                        >
                            <input
                                type="radio"
                                value={location}
                                checked={selectedLocation === location}
                                onChange={handleLocationChange}
                                className="hidden"
                            />
                            {location}
                        </label>
                    ))}
                </div>

                {selectedLocation === 'OFFSITE' && (
                    <div className="card-surface p-4 mb-6">
                        <h4 className="text-xl font-semibold text-gray-700 mb-4">Offsite Details</h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="form-label">Start Time *</label>
                                <input
                                    type="time"
                                    value={startTime}
                                    onChange={(e) => setStartTime(e.target.value)}
                                    className={`input-field ${!startTime ? 'border-red-500' : ''}`}
                                />
                            </div>
                            <div>
                                <label className="form-label">End Time *</label>
                                <input
                                    type="time"
                                    value={endTime}
                                    onChange={(e) => setEndTime(e.target.value)}
                                    className={`input-field ${!endTime ? 'border-red-500' : ''}`}
                                />
                            </div>
                            <div className="md:col-span-2">
                                <label className="form-label">Location *</label>
                                <input
                                    type="text"
                                    value={offsiteLocation}
                                    onChange={(e) => setOffsiteLocation(e.target.value)}
                                    placeholder="e.g., Client Site, Pasig"
                                    className={`input-field ${!offsiteLocation.trim() ? 'border-red-500' : ''}`}
                                />
                            </div>
                            <div className="md:col-span-2">
                                <label className="form-label">Purpose *</label>
                                <textarea
                                    value={offsiteTasks}
                                    onChange={(e) => setOffsiteTasks(e.target.value)}
                                    placeholder="e.g., System deployment"
                                    className={`input-field ${!offsiteTasks.trim() ? 'border-red-500' : ''}`}
                                    rows={3}
                                />
                            </div>
                        </div>
                    </div>
                )}

                {selectedLocation !== 'OFFSITE' && (
                    <div className="mb-6">
                        <label className="form-label">Reason</label>
                        <textarea
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            placeholder="Explain your reason for overtime."
                            rows={4}
                            className="input-field"
                        />
                    </div>
                )}

                <div className="flex flex-col md:flex-row gap-4 justify-center">
                    <button
                        onClick={() => handleClockAction(Transaction.TIME_IN)}
                        className="btn-secondary w-full md:w-40"
                    >
                        Time In
                    </button>
                    <button
                        onClick={() => handleClockAction(Transaction.TIME_OUT)}
                        className="btn-primary w-full md:w-40"
                    >
                        Time Out
                    </button>
                </div>

                {isQrExempted && (
                    <p className="text-center text-green-600 font-medium mt-3 text-sm">
                        QR scan not required for your account.
                    </p>
                )}

                <LoadingDialog loading={loading} />
                <ResponseDialog
                    open={showResponseDialog}
                    onClose={() => setShowResponseDialog(false)}
                    responseMessage={responseMessage}
                    severity={responseSeverity}
                />
                {locationWorkingAtMap[selectedLocation] !== locationWorkingAtMap.OFFSITE &&
                    !isQrExempted &&
                    currentTransaction && (
                        <QRScannerModal onCancel={() => setCurrentTransaction(null)} onScan={handleAttendanceWithQR} />
                    )}
            </div>
        </div>
    )
}

export default OTAttendanceActions
